import { filter, takeUntil } from "rxjs/operators";
import { Component, OnInit, TestabilityRegistry, ViewChild } from "@angular/core";
import { Location, PopStateEvent } from "@angular/common";
import { Router, NavigationEnd, NavigationStart } from "@angular/router";
import { Subject, Subscription, fromEvent } from "rxjs";
import PerfectScrollbar from "perfect-scrollbar";
import { DashboardService } from "app/dashboard/dashboard.service";
import { AuthService } from "app/auth/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { MasterPanelComponent } from "app/masters/master-panel/master-panel.component";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { ReportPanelComponent } from "app/reports/report-panel/report-panel.component";
import { LanguageService } from "app/shared/language.service";
import { labEntryPanelComponent } from "app/labentry/labentry-panel/labentry-panel.component";
import { WebSocketService } from "app/EMR/webSocket.Service";
import { imageworkupService } from "app/EMR/Image_workup/Services/Imageworkup.services";
import { VoiceRecognitionService } from "app/masters/service/voice-recognition.service";
import { ChatbotDialogComponent } from "app/shared/chatbot-dialog/chatbot-dialog.component";
declare const $: any;

@Component({
  selector: "app-admin-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.scss"],
})
export class AdminLayoutComponent implements OnInit {
  private unsubscriber: Subject<void> = new Subject<void>();
  private _router: Subscription;
  @ViewChild(ChatbotDialogComponent) chatbotDialog: ChatbotDialogComponent;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  private mini = true;
  private menuItems: any[];
  private today = new Date();
  private defaultuser: number;
  private isFavorite: boolean = true;
  private showspinner: boolean = false;
  private showPassword: boolean;
  private showPassword1: boolean;
  private showPassword2: boolean;
  private showPassword3: boolean;
  private lenghError: boolean;
  private lenghError2: boolean;

  private headerTitle: String = "";
  private usergender: string;
  private selectedIndex: number = 1;
  private checkroletyle: number = 0;
  private selectedLanguage: any;
  private activeclass: string;
  private areaArray: any;
  private radioOptions: string;
  private subSpeciality: any;
  private moduleName: string = "";
userProfileImageUrl: string 
  constructor(
    private location: Location,
    private dialog: MatDialog,
    private authService: AuthService,
    private dashboardService: DashboardService,
    private router: Router,
    private translate: TranslateService,
    private opdvisitService: OpdVisitService,
    private langservice: LanguageService,
    private WebSocketService:WebSocketService,
    private imageworkupService:imageworkupService,
    private speachtotextservice: VoiceRecognitionService
  ) {
    //   window.addEventListener("beforeunload",(event)=>{
    //     return null;
    // })
    this.dashboardService.getlocations();
    translate.addLangs(["en", "fr", "hi"]);

    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    } else {
      translate.setDefaultLang("en");
    }
    this.getUsertypemenuPermission();
  }

  private userprofilePic() {
    let userpic = this.authService.masterdata.gender;
    if (userpic == "M" || userpic == null) {
      this.usergender = "M";
    } else {
      this.usergender = "F";
    }
  }
  ngOnInit() {
    this.handleImageError()
 if (!sessionStorage.getItem('userPhotoLoaded')) {
    this.loadUserPhoto();
    sessionStorage.setItem('userPhotoLoaded', 'true');
  }
    this.moduleName = "";
    history.pushState(null, "");

    fromEvent(window, "popstate")
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((_) => {
        history.pushState(null, "");
      });
    this.moduleName = this.authService.moduleTypearray.filter(
      (item) => item.pK_Id == this.authService.Loggeduser.specialityId
    )[0]?.name2;
    // this.dashboardService.reportTitle='';
    this.authService.tourGuideDashboard = true;
    var specility = this.authService.areaArray.filter(
      (item) =>
        item.fK_SubSpecialityId == this.authService.LoginsubSpecialityName
    );
    this.subSpeciality = specility[0]?.subSpecialityName
      ? specility[0]?.subSpecialityName
      : null;
    this.radioOptions = this.authService.Loggeduser.role;
    // this.GetAreaData();

    this.userprofilePic();

    this.speachtotextservice.navigationRoute$
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((item) => {
        this.handleNavigationVoiceCommand(item.route, item.command, item.reason);
      });

    const isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;

    if (
      isWindows &&
      !document
        .getElementsByTagName("body")[0]
        .classList.contains("sidebar-mini")
    ) {
      // if we are on windows OS we activate the perfectScrollbar function

      document
        .getElementsByTagName("body")[0]
        .classList.add("perfect-scrollbar-on");
    } else {
      document
        .getElementsByTagName("body")[0]
        .classList.remove("perfect-scrollbar-off");
    }
    const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");
    //const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');

    this.location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev.url;
    });
    this.router.events
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          if (event.url != this.lastPoppedUrl)
            this.yScrollStack.push(window.scrollY);
        } else if (event instanceof NavigationEnd) {
          if (event.url == this.lastPoppedUrl) {
            this.lastPoppedUrl = undefined;
            window.scrollTo(0, this.yScrollStack.pop());
          } else window.scrollTo(0, 0);
        }
      });
    this._router = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((event: NavigationEnd) => {
        elemMainPanel.scrollTop = 0;
      });
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      let ps = new PerfectScrollbar(elemMainPanel);
    }

    const checkdata = this.authService.Roles.filter(
      (item) => item.roleType == "Doctor"
    );
    if (checkdata.length > 0) {
      this.checkroletyle = 1;
    }
    // if(this.authService.moduleTypearray.length ==1){
    //   document.getElementById("noteModelDialog").style.display = "none";
    // }
  }
  menupermissionArray: any = [];
  reportmasterArray: any = [];
  private getUsertypemenuPermission() {
    this.menupermissionArray = [];
    this.reportmasterArray = [];
    this.dashboardService
      .getUsertypemenuPermission()
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((x: any) => {
        if (x.length > 0) {
        
          if (this.checkroletyle == 1) {        
            let newmenu = x.filter(
              (item) =>
                item.webIsMenu == true &&
                item.menuDetailName != "mnuMasters" &&
                item.menuDetailName != "mnuReports" &&
                 item.menuDetailName != "mnuLaboratoryModule" && item.menuDetailName != "mnuUtility"
            );
            this.menupermissionArray = newmenu.sort(
              (a, b) => a.webMenuSeqNo - b.webMenuSeqNo
            );
          
          } else {
            let newmenu = x.filter(
              (item) =>
                item.webIsMenu == true &&
                item.menuDetailName != "mnuDoctorDashboard" &&
                item.menuDetailName != "mnuMasters" &&
                item.menuDetailName != "mnuReports" &&
                item.menuDetailName != "mnuLaboratoryModule" && item.menuDetailName != "mnuUtility"
            );
            this.menupermissionArray = newmenu.sort(
              (a, b) => a.webMenuSeqNo - b.webMenuSeqNo
            );
           
          }
          let reportdata = x.filter(
            (item) =>
              (item.webIsMenu == true && item.menuDetailName == "mnuMasters") ||
              item.menuDetailName == "mnuReports" || item.menuDetailName =="mnuLaboratoryModule"
          );
          this.reportmasterArray = reportdata.sort(
            (a, b) => a.webMenuSeqNo - b.webMenuSeqNo
          );

          this.syncAllowedVoiceRoutesFromMenu();
         
        }
      });
  }

  private syncAllowedVoiceRoutesFromMenu() {
    const allMenuItems: any[] = [...this.menupermissionArray, ...this.reportmasterArray];
    const availableRoutes: string[] = [];
    const dynamicRouteAliases: Array<{ route: string; label?: string; aliases?: string[] }> = [];

    for (const menu of allMenuItems) {
      if (!menu || !menu.webMenuLink) {
        continue;
      }

      const route = String(menu.webMenuLink);
      availableRoutes.push(route);
      dynamicRouteAliases.push({
        route,
        label: menu.webMenuName,
        aliases: [menu.menuDetailName],
      });
    }

    this.speachtotextservice.registerNavigationMenuRoutes(dynamicRouteAliases);
    this.speachtotextservice.setAllowedNavigationRoutes(availableRoutes);
  }

  startNavigationVoiceService() {
    if (!this.speachtotextservice.navigationVoiceDisable) {
      return;
    }
    this.speachtotextservice.navigationVoiceText = "";
    this.speachtotextservice.start("Navigation");
  }

  stopNavigationVoiceService() {
    if (this.speachtotextservice.navigationVoiceDisable) {
      return;
    }
    this.speachtotextservice.stop("Navigation");
  }

  private handleNavigationVoiceCommand(routePath: string | null, voiceCommand: string, reason: 'matched' | 'unrecognized' | 'restricted') {
    if (!voiceCommand) {
      return;
    }

    this.stopNavigationVoiceService();

    if (reason === 'restricted') {
      this.dashboardService.openSnackBar("You don't have permission for this route", "OK");
      return;
    }

    if (!routePath) {
      this.dashboardService.openSnackBar("Command not recognized", "OK");
      return;
    }

    if (this.router.url.toLowerCase() === routePath.toLowerCase()) {
      this.dashboardService.openSnackBar("Already on selected page", "OK");
      return;
    }

    this.dashboardService.openSnackBar("Opening " + voiceCommand, "OK");
    this.router.navigate([routePath], { replaceUrl: true });
  }

  openChatBot() {
    if (this.chatbotDialog) {
      this.chatbotDialog.openChat();
    }
  }

  ngAfterViewInit() {
  
    this.runOnRouteChange();
    
  }
  // private isMaps(path) {
  //   var titlee = this.location.prepareExternalUrl(this.location.path());
  //   titlee = titlee.slice(1);
  //   if (path == titlee) {
  //     return false;
  //   }
  //   else {
  //     return true;
  //   }
  // }
  private runOnRouteChange(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");
      const ps = new PerfectScrollbar(elemMainPanel);
      ps.update();
    }
  }
  private isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }

  sidePanelOver: boolean = false;
  private over() {
    if (this.sidePanelOver == false) {
      if (this.mini) {
        this.isFavorite = false;
        document.getElementById("mySidebar").style.width = "205px";
        if(this.authService.moduleTypearray.length ==2 && this.authService.showspinner ==false){
          document.getElementById("noteModel").style.left = "230px";
        }
      
        this.mini = false;
        document.body.classList.add("expanded");
      } else {
        document.getElementById("mySidebar").style.width = "50px";
        if(this.authService.moduleTypearray.length ==2 && this.authService.showspinner ==false){
          document.getElementById("noteModel").style.left = "75px";
        }
      
        this.mini = true;
        this.isFavorite = true;
        document.body.classList.remove("expanded");
      }
    }
  }


  private toggleSidebar() {
    if (this.mini) {
      this.sidePanelOver = true;
      //   console.log("opening sidebar");
      this.isFavorite = false;
      document.getElementById("mySidebar").style.width = "205px";
      document.getElementById("main").style.marginLeft = "225px";
      if(this.authService.moduleTypearray.length ==2 && this.authService.showspinner ==false){
        document.getElementById("noteModel").style.left = "230px";
      }
      
      this.mini = false;
      document.body.classList.add("expanded");
    } else {
      //   console.log("closing sidebar");
      document.getElementById("mySidebar").style.width = "50px";
      document.getElementById("main").style.marginLeft = "70px";
      if(this.authService.moduleTypearray.length ==2 && this.authService.showspinner ==false){
        document.getElementById("noteModel").style.left = "75px";
      }
     
      this.mini = true;
      this.isFavorite = true;
      this.sidePanelOver = false;
      document.body.classList.remove("expanded");
    }
  }
  private filterrole(roletype: string, roleid) {
    this.authService.selectedrole = null;
    this.authService.Loggeduser.role = roletype;
    this.filterroleid(roleid);
    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() =>
        this.router.navigate(["/layout/dashboard"], { replaceUrl: true })
      );
  }

  private filterroleid(uid) {
    switch (this.authService.Loggeduser.usertypeid) {
      //if usertypeid  is 2 (H & E)
      case 2: {
        this.authService.Loggeduser.userid = uid;
        break;
      }
      // Clinical Department
      case 3: {
        this.authService.Loggeduser.userid = uid;
        break;
      }
      // auto ref
      case 4: {
        this.authService.Loggeduser.userid = uid;
        break;
      }
      //opto
      case 5: {
        this.authService.Loggeduser.userid = uid;
        break;
      }
      //doctor
      case 6: {
        this.authService.Loggeduser.userid = uid;
        break;
      }
      //counslor

      case 7: {
        this.authService.Loggeduser.userid = uid;
        break;
      }
      //procdure
      case 8: {
        this.authService.Loggeduser.userid = uid;
        break;
      }
    }

    // if (this.authService.Loggeduser.usertypeid == 6) {
    //   this.authService.Loggeduser.userid = 3;

    //  }
  }
  private filterb(newbranchid: number, newbranchname: string) {
    this.authService.Loggeduser.branchid = newbranchid;
    this.authService.Loggeduser.branchname = newbranchname;

    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() =>
        this.router.navigate(["/layout/dashboard"], { replaceUrl: true })
      );
  }

  private filterbranch() {
    // console.log("selected user " + this.authService.Loggeduser.usertypeid);

    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() =>
        this.router.navigate(["/layout/dashboard"], { replaceUrl: true })
      );

  }

  private changepasswordpopup() {
    document.getElementById("changepasswordModal").style.display = "block";
    this.authService.oldpasswordtyped = "";
    this.authService.newpassword = "";
    this.authService.confirmpassword = "";
  }

  private changepasswordclose() {
    document.getElementById("changepasswordModal").style.display = "none";
  }

   private changepassword() {
    if (
      this.authService.oldpasswordtyped == "" &&
      this.authService.newpassword == "" &&
      this.authService.confirmpassword == ""
    ) {
      return this.authService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg29"],
        this.authService.validationMsg["Ok"]
      );
    } else if (
      this.authService.oldpasswordtyped != "" &&
      this.authService.newpassword == "" &&
      this.authService.confirmpassword == ""
    ) {
      return this.authService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg30"],
        this.authService.validationMsg["Ok"]
      );
    } else if (
      this.authService.oldpasswordtyped != "" &&
      this.authService.newpassword != "" &&
      this.authService.confirmpassword == "" &&
      this.authService.newpassword.length < 6
    ) {
      return this.authService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg31"],
        this.authService.validationMsg["Ok"]
      );
    } else if (
      this.authService.oldpasswordtyped != "" &&
      this.authService.newpassword != "" &&
      this.authService.confirmpassword == ""
    ) {
      return this.authService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg32"],
        this.authService.validationMsg["Ok"]
      );
    }
    if (this.authService.newpassword.length < 6) {
    this.lenghError = true;
    setTimeout(() => (this.lenghError = false), 2000);
    return;
  }
 
  if (this.authService.newpassword !== this.authService.confirmpassword) {
    this.lenghError2 = true;
    this.dashboardService.openSnackBar('New passowrd and and Confirm password should be same', 'OK')
    setTimeout(() => (this.lenghError2 = false), 2000);
    return;
  }
    let payload={
      UserName:this.authService.Loggeduser.username,
      Password :this.authService.oldpasswordtyped,
      NewPassword:this.authService.newpassword
    }
    this.authService.changepasswordinner(payload).subscribe((item:any)=>{
      this.authService.newpassword = null;
      this.authService.confirmpassword = null;
      this.authService.oldpasswordtyped=null;
      this.authService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg37'], this.authService.validationMsg['Ok']);
    },err=>{
       if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.authService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg25'], this.authService.validationMsg['Ok']);
      }
     
    });
  }
 

  private showHidePassword() {
    this.showPassword = !this.showPassword;
  }
  private showHidePassword1() {
    this.showPassword1 = !this.showPassword1;
  }
  private showHidePassword2() {
    this.showPassword2 = !this.showPassword2;
  }
  private showHidePassword3() {
    this.showPassword3 = !this.showPassword3;
  }

  private showpassword() {
    this.authService.showpassword();
  }

  private logout() {
    // this.translate.setDefaultLang('ar');
    this.authService.Loggedout(2);
    
  }

  private getfinyearstring(finyearid: number) {
    return this.authService.FinYears.find((fy) => fy.pkFinYearId == finyearid)
      .displayFinYear;
  }
  private isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  /** Search Area Master */

  private tourGuidestart() {
    this.opdvisitService.content.next("2");
  }

  private ChangeTitle(id, MenuName: any) {
    this.ngOnDestroy();
    if(id==1){
      this.authService.tourGuideDashboard = true;
      this.dashboardService.reportTitle = "";
      this.activeclass = "activecls";
    }else{
      this.authService.tourGuideDashboard = false;
      this.dashboardService.reportTitle = MenuName;
    }
    this.authService.showspinner = true;
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
    this.dashboardService.subscriptions?.unsubscribe();
    TestabilityRegistry.prototype.registerApplication = () => void 0;
    TestabilityRegistry.prototype.unregisterApplication = () => void 0;
    TestabilityRegistry.prototype.unregisterAllApplications = () => void 0;
    TestabilityRegistry.prototype.getTestability = () => null;
    TestabilityRegistry.prototype.getAllTestabilities = () => [];
    TestabilityRegistry.prototype.getAllRootElements = () => [];
    TestabilityRegistry.prototype.findTestabilityInTree = () => null;
  }

  private blueColor() {
    this.selectedIndex = 1;
    const colorcode = "#1b3465";
    document.documentElement.style.setProperty(
      "--pageButton-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--loginheadbg-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--seticonsbg-colour",
      colorcode
    );
  }
  // orangeColor(){
  //   this.selectedIndex=2;
  //   const colorcode='#F7931E';
  //   document.documentElement.style.setProperty('--pageButton-colour', colorcode);
  //   document.documentElement.style.setProperty('--loginheadbg-colour', colorcode);
  //   document.documentElement.style.setProperty('--seticonsbg-colour', colorcode);
  // }
  private cyanColor() {
    this.selectedIndex = 2;
    const colorcode = "#135c65";
    document.documentElement.style.setProperty(
      "--pageButton-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--loginheadbg-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--seticonsbg-colour",
      colorcode
    );
  }
  private blackColor() {
    this.selectedIndex = 3;
    const colorcode = "#000000";
    document.documentElement.style.setProperty(
      "--pageButton-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--loginheadbg-colour",
      colorcode
    );
    document.documentElement.style.setProperty(
      "--seticonsbg-colour",
      colorcode
    );
  }

  private reportMenu(type) {
  
    if (type == 11) {
      const dialogRef = this.dialog.open(ReportPanelComponent, {
        panelClass: "report-panel-dialog",
        maxWidth: "100vw !important",
      });

      dialogRef.afterClosed().subscribe((result) => {});
    } else if (type == 12) {
      const dialogRef = this.dialog.open(MasterPanelComponent, {
        panelClass: "master-panel-dialog",
        maxWidth: "100vw !important",
      });

      dialogRef.afterClosed().subscribe((result) => {});
    }else if (type == 13) {
      const dialogRef = this.dialog.open(labEntryPanelComponent, {
        panelClass: "labentry-panel-dialog",
        maxWidth: "100vw !important",
      });

      dialogRef.afterClosed().subscribe((result) => {});
    }
  }
  switchLang(lang: string) {
    this.selectedLanguage = lang;
    //console.log('selectedLanguage',this.selectedLanguage)
    this.langservice.switchLang(lang);
  }

  private rolesModal() {
    if (this.authService.DynamicLinks.productType == "LIVE") {
      document.getElementById("rolesModal").style.display = "none";
    } else {
      document.getElementById("rolesModal").style.display = "block";
    }
  }
  privatecancelrolesModal() {
    document.getElementById("rolesModal").style.display = "none";
  }
  private AreaModal() {
    if (this.authService.DynamicLinks.productType == "LIVE") {
      document.getElementById("AreaModal").style.display = "none";
    } else {
      document.getElementById("AreaModal").style.display = "block";
    }
  }
  private cancelAreaModal() {
    document.getElementById("AreaModal").style.display = "none";
  }
  // GetAreaData() {
  //   this.dashboardService.GetUserSubSpecialityByUserId().subscribe(item => {
  //     this.areaArray = item;

  //     console.log(this.areaArray)

  //   })
  // }
  private eyetodentalchange(event) {
    this.dashboardService.moudletype.next(1);
    this.moduleName = this.authService.moduleTypearray.filter(
      (item) => item.pK_Id == this.authService.Loggeduser.specialityId
    )[0]?.name2;
   
  }
 
  private onRadioButtonChange(event) {
    this.authService.Loggeduser.role = event.value;
    this.radioOptions = this.authService.Loggeduser.role;
  }

  closeNoteModelDialog() {
    this.authService.showspinner =true;
    document.getElementById("noteModelDialog").style.display = "none";
  }







 loadUserPhoto() {
  this.opdvisitService.dataSource = [];
  
  if (this.authService.webstorageConfigobj.storageType.toLowerCase() === 'imageserver') {
    this.imageworkupService.getAzureImagedata(this.authService.Loggeduser.userid, this.authService.Loggeduser.branchid, 'USERPHOTO').subscribe(
      (data: any) => {
        this.opdvisitService.dataSource = data;
        if (this.opdvisitService.dataSource.length > 0) {
          const mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() === "mainimagepath");
          
          if (mainimagepath.length > 0) {
            const msg = {
              message: "UPLOADFILE",
              ACTIONTYPE: "VIEWFILE",
              DOCUMENTNAME: this.opdvisitService.dataSource[0].documentName,
              DOCUMENTTYPE: 'USERPHOTO',
              BranchId:  this.authService.Loggeduser.branchid.toString(),
              PATIENTID:this.authService.Loggeduser.userid.toString(),
              MAINIMAGEPATH: mainimagepath[0]?.propertyValue
            };
            
            this.WebSocketService.sendMessage(msg);
            
            this.WebSocketService.getMessages().subscribe(
              (message: any) => {
                if (Array.isArray(message)) {
                  this.userProfileImageUrl = message[0].fbLong
                    ? message[0].fbLong
                    : message[0].documentURL + '?' + Math.floor(Math.random() * 100) + 1;
                } else {
                   this.handleImageError()
                }
              },
              err => {
                this.dashboardService.openSnackBar("Please set server configuration", "OK");
              }
            );
          } else {
            this.dashboardService.openSnackBar("Please set MainImagePath", "OK");
             this.handleImageError()
          }
        } else {
           this.handleImageError()
        }
      },
      err => {
         this.handleImageError()
      }
    );
  } else {
    this.imageworkupService.getAzureImagedata(this.authService.Loggeduser.userid,this.authService.Loggeduser.branchid, 'USERPHOTO').subscribe(
      (data: any) => {
        this.opdvisitService.dataSource = data;
        if (data.length > 0) {
          this.userProfileImageUrl = data[0].fbLong
            ? data[0].fbLong
            : data[0].documentURL + '?' + Math.floor(Math.random() * 100) + 1;
        } else {
           this.handleImageError()
        }
      },
      err => {
       this.handleImageError()
      }
    );
  }
}

handleImageError() {
  this.userProfileImageUrl =
    this.usergender == 'F'
      ? '../assets/img/avatars/avatar-female.png'
      : '../assets/img/avatars/avatar-male.png';
}

}
